// extracted by mini-css-extract-plugin
module.exports = {"power-backup-M":"M_power-backup-M__tyrie"};